import React from 'react';
import { Badge } from 'components/ui/badge';

export function AboutBadge(props: { text: string }) {
  const { text } = props;
  return <Badge className="text-2xl px-4 py-1 rounded-full">{text}</Badge>;
}
